import { useState, useEffect } from 'react';
import { useListenMessage } from '@src/application/hooks/useListenMessage';
import {
  MSG_NAME_FROM_IFRAME,
  MSG_NAME_TO_IFRAME,
  sendMessageFromIframe,
} from '@src/container/handleIframeMessage/handleIframeMessage';

import styles from '@application/modules/shared/components/Header/EventNotification/EventNotification.module.scss';
import { EventNotificationProps } from '@application/modules/shared/type';
import { useAuth } from '@application/modules/flagship/auth/userAuth';

export const AB_TASTY_QA_ASSISTANT_NOTIFICATION = 'AB_TASTY_QA_ASSISTANT_NOTIFICATION' as const;
export const EVENT_NOTIFICATION_TEST_ID = 'event-notification' as const;

export const EventNotification = ({ activeTab }: EventNotificationProps) => {
  const [hitCount, setHitCount] = useState<number>(() => {
    const notificationCount = sessionStorage.getItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION);
    return JSON.parse(notificationCount || '0');
  });
  const { userData } = useAuth();
  const [isQaCollapsed, setIsQaCollapsed] = useState(false);

  useEffect(() => {
    if (activeTab) {
      setHitCount(0);
    }
  }, [activeTab, isQaCollapsed]);

  useEffect(() => {
    sendMessageFromIframe({ name: MSG_NAME_FROM_IFRAME.QaAssistantEventNotification, value: hitCount });
    sessionStorage.setItem(AB_TASTY_QA_ASSISTANT_NOTIFICATION, hitCount.toString());
  }, [hitCount]);

  useListenMessage(
    ({ data }) => {
      if (
        data.name === MSG_NAME_TO_IFRAME.FsHIT &&
        (!activeTab || isQaCollapsed) &&
        userData?.user &&
        userData.access
      ) {
        setHitCount((item) => item + (data?.value?.length || 0));
      }
      if (data.name === MSG_NAME_TO_IFRAME.QaAssistantCollapse && typeof data.value === 'boolean') {
        setIsQaCollapsed(data.value);
      }
    },
    [(!activeTab || isQaCollapsed) && userData?.user && userData.access]
  );

  return hitCount ? (
    <div data-testid={EVENT_NOTIFICATION_TEST_ID} className={styles.notification}>
      {hitCount > 9 ? '9+' : hitCount}
    </div>
  ) : null;
};
